<a
  (click)="!disabled && onClickMenu(link)"
  [class.disabled]="disabled"
  [attr.aria-disabled]="disabled"
  [attr.tabindex]="disabled ? -1 : 0"
  title="{{title}}"
>
  <div class="border d-flex justify-content-start align-items-center">
    <div class="icon bg-light">
      <i class="{{getIcon(icon)}}"></i>
    </div>
    <h5 class="regular mb-0">{{title}}</h5>
  </div>
</a>
